import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Button, Form, Alert, Spinner } from 'react-bootstrap'
import { ContentArea } from '../../components/Page/logix2020/ContentArea'
import { OverlayLeft } from '../../components/Page/logix2020/OverlayLeft'
import { Subheader } from '../../components/Page/logix2020/Subheader'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import { Link } from 'react-router-dom'
import AssetsTable from '../../components/Assets/AssetsTable'
import AssetOverlay from '../../components/Assets/AssetOverlay'
import { useAssetsState } from '../../stores/AssetsProvider'
import OverlayLeftFilter from '../../components/Assets/OverlayLeftFilter'
import useStores from '../../stores/useStore'
import { useTranslation } from 'react-i18next'
import ActiveTableFilters from '../../components/Assets/ActiveTableFilters'
import MediaQuery from 'react-responsive'
import BigFooter from '../../components/Footer/BigFooter'
import { MdLibraryAdd } from 'react-icons/md'
import useMountEffect from '../../utils/hooks/useMountEffect'
import { Observer } from 'mobx-react'

const StyledContentArea = styled(ContentArea)`
  width: 100%;
  padding: 20px 30px 20px 36px;
 .control-row{display:felx; flex-wrap: wrap; align-items: baseline ;}
  @media (max-width: 767px) {
    .mobileButton{ width: 100%; margin-top:16px; margin-bottom:16px;} 
    padding:20px;
    .control-row{display:block; flex-wrap: nowrap; align-items: stretch ;}
  }
  .filterSpaceBetween{
    @media only screen  and (min-width: 768px) {
      display: flex;
      justify-content: space-between; 
      margin-bottom:20px;
    }
  }
`

const AssetsPageContent = () => {
  const {
    setShowAllAssets,
    showDisabledAssets,
    setShowDisabledAssets,
    showOrderableAssets,
    showInventoryableAssets,
    resetFilter,
    selectedRow,
    setSelectedRow,
    showOverlayLeft,
    setShowOverlayLeft,
    updateOverlayLeftStates
  } = useAssetsState()
  const { uiStore } = useStores()
  const { t } = useTranslation()
  useMountEffect(() => {
    if (showOrderableAssets || showInventoryableAssets) {
      resetFilter()
    }
  })
  const handleCloseOverlayRight = useCallback(() => {
    setSelectedRow(false)
  }, [setSelectedRow])

  const handleCloseOverlayLeft = e => {
    setShowOverlayLeft(false)
    updateOverlayLeftStates()
  }

  const onRowClick = (e, row) => {
    setSelectedRow(prev => prev === row ? false : row)
  }
  return (<Observer>{() => (
    <div>
      <Subheader className="subHeader-v1">
        <div className="subheader-title flex-grow-1">{t('assetPage:asset')}</div>
        {<MediaQuery minWidth={768}>
          <Link className="subheader__button btn btn-primary btn-extra-padding" to="/addasset">
            <MdLibraryAdd className="me-3" />{t('assetPage:addNewAsset')}
          </Link>
        </MediaQuery>}
      </Subheader>
      <OverlayLeft className={`overlay-variant ${showOverlayLeft ? 'visible' : ''}`}>
        <div className="header" onClick={handleCloseOverlayLeft}>
          <span onClick={handleCloseOverlayLeft}><i className="close-icon" /></span>
          <span className="header-title">{t('filter')}</span>
        </div>
        <div className="body">
          <OverlayLeftFilter />
        </div>
      </OverlayLeft>
      <StyledContentArea>
        <div className="filterSpaceBetween">
          <div className="control-row">
            {<MediaQuery maxWidth={767}>
              <Link className="btn btn-primary btn-extra-padding w-100" to="/addasset">
                {t('assetPage:addNewAsset')}
              </Link>

            </MediaQuery>}
            <Button variant="secondary" className="mobileButton" onClick={() => { setShowOverlayLeft(prev => !prev) }}>
              {t('allFilters')}
            </Button>
          </div>
          <div className="control-row">
            <Form.Check
              className="me-2"
              type="checkbox"
              id="checkbox"
              checked={showDisabledAssets}
              onChange={(e) => setShowDisabledAssets(e.target.checked)}
              label={t('assetPage:showDeactivatedAssets')}
            />
            <Button variant="secondary" className="btn-extra-padding mobileButton" onClick={() => { resetFilter(); setShowAllAssets(true) }}>
              {t('assetPage:showAllAssets')}
            </Button>
          </div>
        </div>
        <ActiveTableFilters />
        <AssetsTable onRowClick={onRowClick} tableId="Assets" />
      </StyledContentArea>
      <BigFooter />
      <AssetOverlay
        assetEntitiesAdministration={uiStore.allowAssetEntitiesAdministration}
        handleCloseOverlayRight={handleCloseOverlayRight}
        selectedRow={selectedRow}
      />
    </div>
  )}</Observer>)
}



const AssetsPage = () => {

  const { uiStore } = useStores()
  const { t } = useTranslation()
  const [error, setError] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setError(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (<Observer>{() => (
    <>
      {!(uiStore.allowAssetEntitiesAdministration)
        ? (
          <>
            <Subheader className="subHeader-v1">
              <div className="subheader-title">{t('assetPage:asset')}</div>
            </Subheader>
            {error
              ? <Alert variant="danger">{t('assetPage:accessDenied')}</Alert>
              : <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
            }
          </>
        )
        : <AssetsPageContent />
      }
    </>
  )}</Observer>)
}
export default AssetsPage

